import {
  SET_REVENUE,
  SET_ACTIVE_TAB,
  SET_VARIABLE_COSTS,
  SET_FIXED_COSTS,
  SET_MERCHANDISE_COST
} from "./actionTypes";

export const setRevenue = (revenue) => {
  return (dispatch) => {

    dispatch({ type: SET_REVENUE, payload: revenue })
  }
}

export const setActiveTab = (tab) => {
  return (dispatch) => {

    dispatch({ type: SET_ACTIVE_TAB, payload: tab })
  }
}

export const setVariableCosts = (variableCosts) => {
  return (dispatch) => {

    dispatch({ type: SET_VARIABLE_COSTS, payload: variableCosts })
  }
}

export const setFixedCosts = (fixedCosts) => {
  return (dispatch) => {

    dispatch({ type: SET_FIXED_COSTS, payload: fixedCosts })
  }
}

export const setMerchandiseCost = (merchandiseCost) => {
  return (dispatch) => {

    dispatch({ type: SET_MERCHANDISE_COST, payload: merchandiseCost })
  }
}

